import { Host, h } from "@stencil/core";
import { SEGMENTED_CONTROL_EXPORT_PARTS } from "../../common/reserved-names";
/**
 * Segmented control is used to pick one choice from a linear set of closely related choices, and immediately apply that selection.
 */
export class ChSegmentedControl {
    constructor() {
        this.exportParts = SEGMENTED_CONTROL_EXPORT_PARTS;
        this.itemCssClass = "segmented-control-item";
        this.model = undefined;
        this.selectedId = undefined;
    }
    /**
     * Fired when the selected item change. It contains the information about the
     * new selected id.
     */
    selectedItemChange;
    handleSelectedChange(event) {
        event.stopPropagation();
        this.selectedId = event.detail;
        this.selectedItemChange.emit(event.detail);
    }
    #itemRender = (item, index) => {
        const first = index === 0;
        const last = index === this.model.length - 1;
        const between = !first && !last;
        return (h("ch-segmented-control-item", { id: item.id, accessibleName: item.accessibleName, between: between, caption: item.caption, class: item.class || this.itemCssClass, disabled: item.disabled, exportparts: this.exportParts, endImgSrc: item.endImgSrc, endImgType: item.endImgType, first: first, last: last, selected: this.selectedId === item.id, startImgSrc: item.startImgSrc, startImgType: item.startImgType }));
    };
    render() {
        return h(Host, { key: '3c7cd2a7052ac2973ec217d7fb7603b672721ed1', role: "list" }, this.model?.map(this.#itemRender));
    }
    static get is() { return "ch-segmented-control-render"; }
    static get originalStyleUrls() {
        return {
            "$": ["segmented-control-render.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["segmented-control-render.css"]
        };
    }
    static get properties() {
        return {
            "exportParts": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the parts that are exported by the internal\nsegmented-control-item. This property is useful to override the exported\nparts."
                },
                "attribute": "export-parts",
                "reflect": false,
                "defaultValue": "SEGMENTED_CONTROL_EXPORT_PARTS"
            },
            "itemCssClass": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "A CSS class to set as the `ch-segmented-control-item` element class.\nThis default class is used for the items that don't have an explicit class."
                },
                "attribute": "item-css-class",
                "reflect": false,
                "defaultValue": "\"segmented-control-item\""
            },
            "model": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "SegmentedControlModel",
                    "resolved": "SegmentedControlItemModel[]",
                    "references": {
                        "SegmentedControlModel": {
                            "location": "import",
                            "path": "./types",
                            "id": "src/components/segmented-control/types.ts::SegmentedControlModel"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "This property lets you define the items of the ch-segmented-control-render\ncontrol."
                }
            },
            "selectedId": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the ID of the selected item"
                },
                "attribute": "selected-id",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "selectedItemChange",
                "name": "selectedItemChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fired when the selected item change. It contains the information about the\nnew selected id."
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }];
    }
    static get listeners() {
        return [{
                "name": "selectedChange",
                "method": "handleSelectedChange",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
